import { Typography } from '@mui/material';
import { Row, Spacer } from '../components';
import { Svgs } from '../assets/svg';
import { useTranslation } from 'react-i18next';

interface PasswordReqProps {
  hasMinChar: boolean;
  hasANumber: boolean;
  hasUpperCase: boolean;
  hasLowerCase: boolean;
  hasSpecialChar: boolean;
}

export const PasswordRequirements: React.FC<PasswordReqProps> = ({
  hasMinChar,
  hasANumber,
  hasUpperCase,
  hasLowerCase,
  hasSpecialChar,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        {hasMinChar ? <Svgs.IconCheckmarkGreen /> : <Svgs.DisplayExtraSmallCustomX />}
        <Spacer width='xxs' />
        <Typography variant='p12' color={hasMinChar ? 'success.main' : 'error.main'}>
          {t('PasswordRulesLength')}
        </Typography>
      </Row>
      <Spacer height='xxs' />
      <Row>
        {hasANumber ? <Svgs.IconCheckmarkGreen /> : <Svgs.DisplayExtraSmallCustomX />}
        <Spacer width='xxs' />
        <Typography variant='p12' color={hasANumber ? 'success.main' : 'error.main'}>
          {t('PasswordRulesNumeric')}
        </Typography>
      </Row>
      <Spacer height='xxs' />
      <Row>
        {hasUpperCase ? <Svgs.IconCheckmarkGreen /> : <Svgs.DisplayExtraSmallCustomX />}
        <Spacer width='xxs' />
        <Typography variant='p12' color={hasUpperCase ? 'success.main' : 'error.main'}>
          {t('PasswordRulesUpperCase')}
        </Typography>
      </Row>
      <Spacer height='xxs' />
      <Row>
        {hasLowerCase ? <Svgs.IconCheckmarkGreen /> : <Svgs.DisplayExtraSmallCustomX />}
        <Spacer width='xxs' />
        <Typography variant='p12' color={hasLowerCase ? 'success.main' : 'error.main'}>
          {t('PasswordRulesLowerCase')}
        </Typography>
      </Row>
      <Spacer height='xxs' />
      <Row>
        {hasSpecialChar ? <Svgs.IconCheckmarkGreen /> : <Svgs.DisplayExtraSmallCustomX />}
        <Spacer width='xxs' />
        <Typography variant='p12' color={hasSpecialChar ? 'success.main' : 'error.main'}>
          {t('PasswordRulesSpecialChar')}
        </Typography>
      </Row>
    </>
  );
};
